import { AxiosInstance } from "axios";

import { BaseAPI } from "../../classes/BaseAPI";

export class StaffAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }
}